export default "__VITE_ASSET__BNmGqTwY__"